import { render, staticRenderFns } from "./StructureReport.vue?vue&type=template&id=817fc0c4"
import script from "./StructureReport.vue?vue&type=script&lang=js"
export * from "./StructureReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports